module.exports = __webpack_public_path__ + "img/Electricite_de_savoie_120X35.8b32c865.png";